const initialState = {
  items: [],
  count: 0,
  item: null,
  isLoading: false,
};

export function paymentReducer(state = initialState, action) {
  const { data, payment: item, type } = action;
  switch (type) {
    case 'PAYMENT_ERROR':
      return Object.assign({}, state, {
        isLoading: false,
      });
    case 'PAYMENT_CREATE':
      return Object.assign({}, state, {
        item: null,
        isLoading: true,
      });
    case 'PAYMENT_CREATE_OK':
      return Object.assign({}, state, {
        item,
        isLoading: false,
      });

    case 'PAYMENT_GET':
      return Object.assign({}, state, {
        item: null,
        isLoading: true,
      });
    case 'PAYMENT_GET_OK':
      return Object.assign({}, state, {
        item,
        isLoading: false,
      });

    case 'PAYMENTS_GET':
      return Object.assign({}, state, {
        items: [],
        count: 0,
        isLoading: true,
      });
    case 'PAYMENTS_GET_OK':
      return Object.assign({}, state, {
        items: data.items,
        count: data.count,
        isLoading: false,
      });

    default:
      return state;
  }
}
